// extracted by mini-css-extract-plugin
export default {"callback_tabs_wrapper":"ShippingCallbackConfigurator-module_callback_tabs_wrapper__ZO_RD"};